import {config} from "@commons/config.instance";
import axios from "axios";
import Axios from "axios";
import {AziendaFruibileRecord} from "@commons/mapping/AziendaFruibileRecord";
import {Views} from "@commons/Views";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import {addBaseQueryParams, addQueryParams, BaseQueryParams} from "@commons/utils/APIParams";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";

/**
 * url esempio: https://fpnet2.ericed.it/FPNet2021/access/domain/current/company-employee?auth_token=a0e931b757f7b45bc0f9dad6e39f3fbe&nowId=1691662643345&view=Full
 * @param filter
 */
export const listAziendeXEmployee = (view: Views = 'Minimal') => {
    const url = config.getBaseUrl('FPNet') + `/access/domain/current/company-employee?view=${view}`;

    return axios<AziendaFruibileRecord[]>(url).then(
        (res) => {
            if (res.status === 200) { // @ts-ignore
                return Object.keys(res.data).map(i => res.data[i]);
            } // todo "sistemare" backend e rimuovere conversione!
            else
                return [];
        },

        (res) => {
            throw res;
        });
}

/**
 * Api per cambio dominio
 * @param idDominio
 */
export function cambiaDominio(idDominio: number): Promise<TokenRecord> {

    const url = config.getBaseUrl('FPNet') + `/access/domain/current/${idDominio}`;
    return Axios.put<TokenRecord>(url, {})
        .then(res => {
            return res.data;
        });
}

/**
 * Imposta il dominio e l'azienda indicati
 * url esempio: https://fpnet2.ericed.it/FPNet2021/access/domain/current/1001?idAzienda=2096
 */

export const cambiaDominioEAzienda = ({idDominio, idAzienda}: { idDominio: number, idAzienda: number }) => {

    const url = config.getBaseUrl('FPNet') + `/access/domain/current/${idDominio}?idAzienda=${idAzienda}`;
    return Axios.put<TokenRecord>(url, {})
        .then(res => {
            return res.data;
        });
}
export const cambiaAzienda = ({idAzienda}: { idAzienda: number }) => {

    const url = config.getBaseUrl('FPNet') + `/access/domain/current/azienda/${idAzienda}`;
    return Axios.put<TokenRecord>(url, {})
        .then(res => {
            return res.data;
        });
}

interface AziendaParams extends Partial<BaseQueryParams> {
    idAzienda: number
}

export const getAzienda = (params: AziendaParams) => {

    const queryParams: string[] = addBaseQueryParams(params);
    //queryParams.push(`anno=${params.anno}`);
    //queryParams.push(`mese=${params.mese}`);
    const url = config.getBaseUrl('FPNet') + `/azienda/${params.idAzienda}?${addQueryParams(queryParams)}`
    return axios<AziendaRecord>(url).then(res => res.data);
}
